import { TrendingUp, Users, Heart, Mic, ShieldCheck } from "lucide-react";

const outcomes = [
    {
        title: "Increased Student Engagement",
        icon: TrendingUp,
        color: "bg-[#16bdf4]",
    },
    {
        title: "Improved Peer Relationships",
        icon: Users,
        color: "bg-[#ffbc00]",
    },
    {
        title: "Greater Empathy and Inclusion",
        icon: Heart,
        color: "bg-[#ff5fa2]",
    },
    {
        title: "Stronger Student Voice and Leadership",
        icon: Mic,
        color: "bg-[#22c55e]",
    },
    {
        title: "Reduced Tolerance for Bullying Behaviors",
        icon: ShieldCheck,
        color: "bg-[#a855f7]",
    },
];

export default function SchoolsOutcomes() {
    return (
        <section className="relative overflow-hidden bg-[#f8f4ea] px-6 py-16 lg:px-8">
            {/* Optional background image / paper texture placeholder */}
            <div
                className="absolute inset-0 bg-cover bg-center opacity-10"
                style={{
                    backgroundImage: "url('/assets/schools/outcomes-bg.png')",
                }}
            />

            <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(0,0,0,0.08)_1px,transparent_1px)] [background-size:14px_14px] opacity-50" />

            <div className="relative mx-auto max-w-6xl">
                <div className="mx-auto mb-10 max-w-3xl text-center">
                    <div className="mb-4 inline-flex rotate-[-1deg] items-center gap-2 border-[3px] border-black bg-[#ff3366] px-4 py-2 text-sm font-black uppercase text-white shadow-[4px_4px_0_#000]">
                        <TrendingUp size={18} strokeWidth={3} />
                        Outcomes
                    </div>

                    <h2 className="text-3xl font-black uppercase leading-none md:text-4xl">
                        Outcomes Schools Can Expect
                    </h2>

                    <p className="mx-auto mt-4 max-w-2xl text-base font-bold leading-7 md:text-lg">
                        Schools using dialogue-based tools like Call It Out can help
                        students build stronger relationships, greater empathy, and more
                        confidence speaking up.
                    </p>
                </div>

                <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-5">
                    {outcomes.map((outcome) => {
                        const Icon = outcome.icon;

                        return (
                            <section
                                key={outcome.title}
                                className="rounded-[22px] border-[4px] border-black bg-white p-5 shadow-[6px_6px_0_#000]"
                            >
                                <div
                                    className={`mb-4 flex h-12 w-12 items-center justify-center rounded-full border-[3px] border-black ${outcome.color} shadow-[3px_3px_0_#000]`}
                                >
                                    <Icon size={24} strokeWidth={3} />
                                </div>

                                <h3 className="text-lg font-bold uppercase leading-tight">
                                    {outcome.title}
                                </h3>
                            </section>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}